// Company List
export const COMPANY_LIST_REQUEST = 'COMPANY_LIST_REQUEST';
export const COMPANY_LIST_SUCCESS = 'COMPANY_LIST_SUCCESS';
export const COMPANY_LIST_FAIL = 'COMPANY_LIST_FAIL';

// Company Create
export const COMPANY_CREATE_REQUEST = 'COMPANY_CREATE_REQUEST';
export const COMPANY_CREATE_SUCCESS = 'COMPANY_CREATE_SUCCESS';
export const COMPANY_CREATE_FAIL = 'COMPANY_CREATE_FAIL';
export const COMPANY_CREATE_RESET = 'COMPANY_CREATE_RESET';

// Company Details
export const COMPANY_DETAILS_REQUEST = 'COMPANY_DETAILS_REQUEST';
export const COMPANY_DETAILS_SUCCESS = 'COMPANY_DETAILS_SUCCESS';
export const COMPANY_DETAILS_FAIL = 'COMPANY_DETAILS_FAIL';

// Company Update
export const COMPANY_UPDATE_REQUEST = 'COMPANY_UPDATE_REQUEST';
export const COMPANY_UPDATE_SUCCESS = 'COMPANY_UPDATE_SUCCESS';
export const COMPANY_UPDATE_FAIL = 'COMPANY_UPDATE_FAIL';
export const COMPANY_UPDATE_RESET = 'COMPANY_UPDATE_RESET';

// Company Delete
export const COMPANY_DELETE_REQUEST = 'COMPANY_DELETE_REQUEST';
export const COMPANY_DELETE_SUCCESS = 'COMPANY_DELETE_SUCCESS';
export const COMPANY_DELETE_FAIL = 'COMPANY_DELETE_FAIL';

// Company Toggle Status
export const COMPANY_TOGGLE_STATUS_REQUEST = 'COMPANY_TOGGLE_STATUS_REQUEST';
export const COMPANY_TOGGLE_STATUS_SUCCESS = 'COMPANY_TOGGLE_STATUS_SUCCESS';
export const COMPANY_TOGGLE_STATUS_FAIL = 'COMPANY_TOGGLE_STATUS_FAIL';

// Company Stats
export const COMPANY_STATS_REQUEST = 'COMPANY_STATS_REQUEST';
export const COMPANY_STATS_SUCCESS = 'COMPANY_STATS_SUCCESS';
export const COMPANY_STATS_FAIL = 'COMPANY_STATS_FAIL';
